import {
  ProductListEditPath,
  ProductListPreviewPath,
  ProductListProductListPath,
  ProductListRetailerListPath,
  ProductListStoreListPath,
} from '@/modules/product/paths';

export interface ProductListDetailNavLink {
  label: string;
  to: string;
  end?: boolean;
}

export const getProductListDetailNavLinks = (productListId: string): ProductListDetailNavLink[] => [
  { label: 'Overview', to: ProductListEditPath.withId(productListId), end: true },
  {
    label: 'Products in List',
    to: ProductListProductListPath.withProductListId(productListId),
  },
  { label: 'Retailers', to: ProductListRetailerListPath.withProductListId(productListId) },
  { label: 'Stores', to: ProductListStoreListPath.withProductListId(productListId) },
  { label: 'Preview', to: ProductListPreviewPath.withProductListId(productListId) },
];
